import React, { useEffect, useState, useRef } from 'react';
import styles from './TasksPage.module.css';
import TasksHeader from './TasksHeader/TasksHeader';
import DailyTasks from './DailyTasks/DailyTasks';
import BalanceTop from '../../components/BalanceTop/BalanceTop';
import PartnerTasks from './PartnerTasks/PartnerTasks';
import { TaskModal } from './PartnerTasks/TasksModal';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import type { WebApp } from '../../types/telegram';
// import LeadCard from './LeadCard';
import {ReactComponent as StarIcon} from '../../assets/Inventory/stars.svg'
import UserInfoTop from '../../components/UserInfoTop/UserInfoTop';

interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const TasksPage = () => {
  const [isBackgroundLoaded, setIsBackgroundLoaded] = useState(false);
  const [isDailyTasksLoaded, setIsDailyTasksLoaded] = useState(false);
  const [isPartnerTasksLoaded, setIsPartnerTasksLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Проверяем загрузку всех компонентов
  const isAllLoaded =
    isBackgroundLoaded && isDailyTasksLoaded && isPartnerTasksLoaded;

  // Создаем стабильные callback'и
  const handleDailyTasksLoadingChange = React.useCallback(
    (isLoading: boolean) => {
      setIsDailyTasksLoaded(!isLoading);
    },
    [],
  );

  const handlePartnerTasksLoadingChange = React.useCallback(
    (isLoading: boolean) => {
      setIsPartnerTasksLoaded(!isLoading);
    },
    [],
  );

  useEffect(() => {
    const tg = window.Telegram?.WebApp as ExtendedWebApp;
    if (!tg) return;

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, []);

  useEffect(() => {
    console.log('Начинаем загрузку фонового изображения');
    const img = new Image();
    img.onload = () => {
      console.log('Фоновое изображение загружено успешно');
      setIsBackgroundLoaded(true);
    };
    img.onerror = () => {
      console.log('Ошибка загрузки фонового изображения, продолжаем без него');
      setIsBackgroundLoaded(true);
    };

    img.src = '@/assets/backgrounds/TasksPageBackground.webp';

    // Если не загрузилось за 10 секунд, считаем загруженным
    const timeout = setTimeout(() => {
      console.log('Таймаут загрузки фонового изображения');
      setIsBackgroundLoaded(true);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  console.log('Состояния загрузки:', {
    isBackgroundLoaded,
    isDailyTasksLoaded,
    isPartnerTasksLoaded,
    isAllLoaded,
  });

  const [fadeVisible, setFadeVisible] = React.useState(false);

  React.useEffect(() => {
    if (isAllLoaded) {
      setFadeVisible(false);
      requestAnimationFrame(() => setFadeVisible(true));
    }
  }, [isAllLoaded]);

  // Показываем лоадер только через 2 секунды после начала загрузки
  React.useEffect(() => {
    if (!isAllLoaded) {
      const timer = setTimeout(() => {
        setShowLoader(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setShowLoader(false);
    }
  }, [isAllLoaded]);

  return (
    <div ref={containerRef} className={styles.container}>
      <TaskModal />

      {/* <TasksHeader /> */}

      <div className={styles.container__contentContainer}>
        {!isAllLoaded && (
          <div className={styles.container__loaderContainer}>
            <CustomLoader />
          </div>
        )}

        <div
          className={`${styles.fade} ${fadeVisible ? styles.fadeVisible : ''}`}
          style={{ visibility: isAllLoaded ? 'visible' : 'hidden' }}
        >
          <div className={styles.container__content}>
            <BalanceTop />
            <UserInfoTop/>
            <div className={styles.inventoryBanner}>
              <div className={styles.dollarContainer}>
                <span className={`${styles.dollarSign} ${styles.dollar1}`}>$</span>
                <span className={`${styles.dollarSign} ${styles.dollar2}`}>$</span>
                <span className={`${styles.dollarSign} ${styles.dollar3}`}>$</span>
                <span className={`${styles.dollarSign} ${styles.dollar4}`}>$</span>
                <span className={`${styles.dollarSign} ${styles.dollar5}`}>$</span>
              </div>
              <div className={styles.inventoryBanner__text}>
                <div className={styles.inventoryBanner__header}>
                  Quest
                </div>
                <div className={styles.inventoryBanner__p}>
                  Выполняйте задания и<br/> получайте спины и билеты
                </div>
              </div>
              <div className={styles.inventoryBanner__icons}>
                <div className={styles.inventoryBanner__vector}></div>
                <div className={styles.inventoryBanner__background}></div>
              </div>
            </div>
            <div className={styles.leaderboardContainer}>
              <DailyTasks onLoadingChange={handleDailyTasksLoadingChange} />
              <PartnerTasks onLoadingChange={handlePartnerTasksLoadingChange} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksPage;
